import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'transformNumber'
})
export class TransformNumberPiPe implements PipeTransform {
    transform(value, roundDigit = 2) {
        if (parseFloat(value) === 0) {
            return '0.00';
        }
        if (!value) {
            return;
        }

        if (isNaN(parseFloat(value))) {
            return value;
        }

        const parts = roundDigit ? parseFloat(value).toFixed(roundDigit).toString().split('.') : parseFloat(value).toString().split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return parseFloat(value) > 0 ? parts.join('.') : `(${parts.join('.').replace('-', '')})`;
    }
}
